module.exports = {
        srcSet: __webpack_public_path__ + "bdd04f065ac9b100-1000.webp"+" 1000w",
        images: [{path: __webpack_public_path__ + "bdd04f065ac9b100-1000.webp",width: 1000,height: 562}],
        src: __webpack_public_path__ + "bdd04f065ac9b100-1000.webp",
        toString: function(){return __webpack_public_path__ + "bdd04f065ac9b100-1000.webp"},
        
        width: 1000,
        height: 562
      }